export function getPercentage(value: number, total: number) {
  if (total === 0 || value == null) {
    return 0;
  }

  return (value / total) * 100;
}
